import { ReactNode } from "react";

interface Props {
  title: string;
  /** 제목 옆에 붙는 한 줄 요약(건수·기간 등). */
  meta?: ReactNode;
  description?: string;
  /** 오른쪽 정렬 액션 영역. */
  actions?: ReactNode;
}

/**
 * 화면 제목. 가운데 정렬 큰 제목은 첫 화면의 세로를 200px 넘게 잡아먹어
 * 목록을 보려면 스크롤을 내려야 했다. 왼쪽 정렬 한 줄로 줄인다.
 */
const PageHeader = ({ title, meta, description, actions }: Props) => {
  return (
    <div className="flex flex-wrap items-end justify-between gap-2">
      {/* grow — 버튼과 한 줄이면 남은 폭을 다 받아 메타가 그 폭으로 꺾인다. 폰(md 미만)은 메타가 제목 아래 줄로 가고 폭 계산에서 빠져 제목이 눌리지 않는다. */}
      <div className="flex min-w-0 grow flex-col gap-y-1">
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {meta && <span className="w-0 min-w-full text-sm text-muted-foreground md:w-auto md:min-w-0">{meta}</span>}
        </div>
        {description && (
          <p className="text-sm text-muted-foreground">{description}</p>
        )}
      </div>

      {actions && <div className="flex flex-wrap items-center justify-start gap-2 md:justify-end">{actions}</div>}
    </div>
  );
};

export default PageHeader;
